import { render, staticRenderFns } from "./phone_verification_page.vue?vue&type=template&id=37b6ff40&scoped=true&"
import script from "./phone_verification_page.vue?vue&type=script&lang=js&"
export * from "./phone_verification_page.vue?vue&type=script&lang=js&"
import style0 from "./phone_verification_page.vue?vue&type=style&index=0&id=37b6ff40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b6ff40",
  null
  
)

export default component.exports